var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('sui-container',[_c('div',{attrs:{"id":"logo"},on:{"click":_vm.goHome}}),_c('div',{attrs:{"id":"banner"}}),_c('Home'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }